import { ReactNode, useEffect, useRef } from 'react'

interface HubSpotCTAProps {
  portalId?: string
  ctaId: string
  style: any
  children: ReactNode
}

const HubSpotCTA = ({
  children,
  ctaId,
  portalId = '48114419',
  style,
}: HubSpotCTAProps) => {
  const ctaRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://js.hscta.net/cta/current.js'
    script.async = true
    document.body.appendChild(script)

    script.onload = () => {
      // @ts-ignore
      if (window.hbspt) {
        // @ts-ignore
        window.hbspt.cta.load(portalId, ctaId, { el: ctaRef.current })
      }
    }

    return () => {
      document.body.removeChild(script)
    }
  }, [portalId, ctaId])

  return (
    <div
      ref={ctaRef}
      className='hs-cta-embed hs-cta-simple-placeholder'
      style={style}
    >
      {children}
    </div>
  )
}

export default HubSpotCTA
